export const municipiosPara = [
  "Almeirim","Afuá","Alenquer","Baião","Belterra","Breu Branco","Breves",
  "Cametá","Curuá","Chaves","Gurupá","Limoeiro do Ajurú","Monte Alegre",
  "Oeiras","Porto de Moz","Prainha","Placas","Santarém","São Sebastião da Boa Vista"
];

export const municipiosAmapa = [
  "Amapá","Calçoene","Cutias do Araguari","Laranjal do Jari","Macapá",
  "Mazagão","Porto Grande","Santana","Tartarugalzinho","Vitória do Jari"
];
